/**
 * ColumnSeriesSummaryRow — `column.series-summary` renderer. Thumbnail
 * over a `(number, series)` source (min / mean / max). Stub until the
 * derivation index lands — mirrors the current `SeriesSummaryRow`.
 */

import { RendererRow } from "./renderer-row.ts";
import { SourceRow } from "./source-row.ts";

/**
 * The `column.series-summary` renderer row: a thumbnail (min, mean, max) of its source row's series
 * per column.
 */
export class ColumnSeriesSummaryRow extends RendererRow {
  get source(): SourceRow {
    const p = this.parent;
    if (!(p instanceof SourceRow)) {
      throw new Error(
        `ColumnSeriesSummaryRow: parent of ${this.id.rawId} is not a SourceRow ` +
          `(got ${p?.constructor.name ?? "undefined"}).`,
      );
    }
    return p;
  }

  summary(): { min?: number; mean?: number; max?: number } {
    throw new Error(
      "ColumnSeriesSummaryRow.summary: stub — requires derivation index.",
    );
  }
}
